export default "__VITE_ASSET__bcbddc83__"